import React, { useState, useMemo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { decrement, increment, removeAllCart, removeFromCart } from '../../Redux/Slice/Cart/cartSlice'
import toast from 'react-hot-toast'
import { applyCopoun } from '../../Services/CartServices'
import { couponAmount, setGrandTotal, totalOrderAmount } from '../../Redux/Slice/Checkout/checkoutSlice'

const useCartDetail = () => {
    const { user } = useSelector((state) => state.user)
    const cartItems = useSelector(state => state.cart)
    const [amount, setAmount] = useState(0)
    const [code, setCode] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [coupone, setCoupone] = useState({})
    const dispatch = useDispatch()
    const [discountAmount, setDiscountAmount] = useState("")

    const handleRemove = (val) => {
        dispatch(removeFromCart(val))
    }
    const handleIncreament = (val) => {
        dispatch(increment(val))
    }
    const handleDecreament = (val) => {
        dispatch(decrement(val))
    }

    const handleCode = (e) => {
        setCode(e.target.value)
    }

    const totalAmount = useMemo(() => {
        let price = 0
        if (cartItems?.cart?.length > 0) {
            cartItems.cart.forEach((i) => {
                price += i.price * i.quantity
            })
        }
        return price.toLocaleString()
    }, [cartItems.cart])

    const totalAmountNumeric = useMemo(() => {
        let price = 0;
        if (cartItems?.cart?.length > 0) {
            cartItems.cart.forEach((i) => {
                price += i.price * i.quantity;
            });
        }
        return price;
    }, [cartItems.cart]);

    const myTotalAmount = () => {
        let price = 0;
        if (cartItems?.cart?.length > 0) {
            cartItems.cart.forEach((i) => {
                price += i.price * i.quantity;
            });
        }
        return price;
    }


    useEffect(() => {
        setAmount(parseFloat(totalAmount.replace(/,/g, '')) || 0)

    }, [totalAmount])

    useEffect(() => {
        if (coupone?.value) {
            setDiscountAmount((parseFloat(coupone.value) || 0));
        }
        setAmount(parseFloat(totalAmount.replace(/,/g, '')) || 0)
    }, [coupone, amount]);

    const removeAll = () => {
        dispatch(removeAllCart())
    }

    useEffect(() => {
        if (discountAmount !== null) {
            localStorage.setItem('discountedAmount', discountAmount);
        }
    }, [discountAmount]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        let response = await applyCopoun({ code, amount });
        if (response.statusCode === 200) {
            const discountValue = parseFloat(response?.response?.data?.value) || 0;
            const newDiscountAmount = discountValue; // Corrected calculation
            dispatch(couponAmount(discountValue))
            let myTotal = myTotalAmount()
            console.log("mytotal", myTotal)
            dispatch(totalOrderAmount(myTotal))
            setCoupone(response?.response?.data);
            setCode("");
            setDiscountAmount(newDiscountAmount);
            toast.success(response.message);
        } else if (response.statusCode === 401) {
            toast.error(response.errors);

        } else {
            Object.values(response.errors).forEach(error => {
                toast.error(error);
            });
        }

        setIsLoading(false);
    };



    return [
        cartItems,
        isLoading,
        code,
        handleDecreament,
        handleIncreament,
        handleRemove,
        totalAmount, // replace calculatePrice with totalAmount
        removeAll,
        handleSubmit,
        handleCode,
        discountAmount,
        totalAmountNumeric,
        user,
    ]
}

export default useCartDetail
